module.exports = __webpack_public_path__ + "img/sls.f98bc0a9.svg";